/**
 * The page of the selection of the module.
 *
 * Copyright © Ircam Amplify 2024-2026
 */
import '@/components/styles/Input.css'
import './TaskCreationModuleSelectionPage.css'

import { ModuleSelector } from '@/pages/TaskCreation/ModuleSelector'

export const TaskCreationModuleSelectionPage = () => (
  <div className="jobui-globalContainer task-creation-module-selection-page">
    <div className="jobui-createContainer">
      <div className="header">
        <h1 className="page-title">What are we making ?</h1>
      </div>
      <div className="jobui-section">
        <ModuleSelector />
      </div>
    </div>
  </div>
)
